__webpack_require__.p = "https://resources.alaiamind.com/";